import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import setupLocalStorageAPI from "utils/setupLocalStorageAPI";

type DialogsFilter = "all" | "assigned" | "assigned-to-me";

interface InboxState {
  includeMessagesFromOtherClinics: boolean;
  orderByMostRecentMessage: boolean;
  hideAutomatedTexts: boolean;
  dialogsFilter: DialogsFilter;
}

const includeMessagesFromOtherClinicsStorage = setupLocalStorageAPI(
  "includeMessagesFromOtherClinics"
);

const orderByMostRecentMessageStorage = setupLocalStorageAPI(
  "orderByMostRecentMessage"
);

const initialState: InboxState = {
  includeMessagesFromOtherClinics:
    includeMessagesFromOtherClinicsStorage.getData(true),
  orderByMostRecentMessage: orderByMostRecentMessageStorage.getData(false),
  hideAutomatedTexts: false,
  dialogsFilter: "all",
};

const inboxSlice = createSlice({
  name: "inbox",
  initialState,
  reducers: {
    setIncludeMessagesFromOtherClinics: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.includeMessagesFromOtherClinics = action.payload;
    },
    toggleIncludeMessagesFromOtherClinics: (state) => {
      state.includeMessagesFromOtherClinics =
        !state.includeMessagesFromOtherClinics;
      includeMessagesFromOtherClinicsStorage.updateData(
        state.includeMessagesFromOtherClinics
      );
    },
    toggleOrderByMostRecentMessage: (state) => {
      state.orderByMostRecentMessage = !state.orderByMostRecentMessage;
      orderByMostRecentMessageStorage.updateData(
        state.orderByMostRecentMessage
      );
    },
    setHideAutomatedTexts: (state, action: PayloadAction<boolean>) => {
      state.hideAutomatedTexts = action.payload;
    },
    toggleHideAutomatedTexts: (state) => {
      state.hideAutomatedTexts = !state.hideAutomatedTexts;
    },
    setDialogsFilter: (state, action: PayloadAction<DialogsFilter>) => {
      state.dialogsFilter = action.payload;
    },
  },
});

export const {
  setIncludeMessagesFromOtherClinics,
  toggleIncludeMessagesFromOtherClinics,
  toggleOrderByMostRecentMessage,
  setHideAutomatedTexts,
  toggleHideAutomatedTexts,
  setDialogsFilter,
} = inboxSlice.actions;

export const selectInboxState = (state: { inbox: InboxState }) => state.inbox;

export const getIncludeMessagesFromOtherClinicsState = (state: {
  inbox: InboxState;
}): boolean => state.inbox.includeMessagesFromOtherClinics;

export const getOrderByMostRecentMessageState = (state: {
  inbox: InboxState;
}) => state.inbox.orderByMostRecentMessage;

export const getHideAutomatedTextsState = (state: {
  inbox: InboxState;
}): boolean => state.inbox.hideAutomatedTexts;

export const getDialogsFilterState = (state: {
  inbox: InboxState;
}): DialogsFilter => state.inbox.dialogsFilter;

export default inboxSlice.reducer;
//
